/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserNotificationSettingsDto } from '../../models/update-user-notification-settings-dto';
import { UserNotificationSettingsResponseDto } from '../../models/user-notification-settings-response-dto';

export interface UpdateUserNotificationSettings$Params {
  id: number;
  'X-API-Version'?: string;
      body: UpdateUserNotificationSettingsDto
}

export function updateUserNotificationSettings(http: HttpClient, rootUrl: string, params: UpdateUserNotificationSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UserNotificationSettingsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updateUserNotificationSettings.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserNotificationSettingsResponseDto>;
    })
  );
}

updateUserNotificationSettings.PATH = '/api/users/{id}/notification-settings';
